import React, { useEffect, useState } from 'react';
import { Grid } from '@material-ui/core';
import AppTextInput from '@jumbo/components/Common/formElements/AppTextInput';
import { handleRutChange, LABEL_INPUT_FONT_SIZE, validateField, validateMail, validateRut, validateWebUrl } from '../../ConstsAndUtils/utils';

const IdentificacionPrestador = props => {
  /* falta validar correo y rut */

  const {
    nombre,
    razon,
    rut,
    codigo,
    telefono,
    correo,
    web,
    setNombre,
    setRazon,
    setRut,
    setCodigo,
    setTelefono,
    setCorreo,
    setWeb,
  } = props;

  const [nameError, setNameError] = useState('');
  const [razonSocialError, setRazonSocialError] = useState('');
  const [rutError, setRutError] = useState('');
  const [deisError, setDeisError] = useState('');
  const [telefonoError, setTelefonoError] = useState('');
  const [correoError, setCorreoError] = useState('');
  const [webError, setWebError] = useState('');

  useEffect(() => {

    if (nombre === '') {
      setNameError('Campo obligatorio')
    } else {
      setNameError('')
    }

    if (razon === '') {
      setRazonSocialError('Campo obligatorio')
    } else {
      setRazonSocialError('')
    }

    if (rut === '') {
      setRutError('Campo obligatorio')
    } else {
      if (validateRut(rut)) {
        setRutError('')
      } else {
        setRutError('RUT inválido')
      }

    }

    if (codigo === '') {
      setDeisError('Campo obligatorio')
    } else {
      setDeisError('')
    }

    if (telefono === '+56') {
      setTelefonoError('Campo obligatorio')
    } else {
      setTelefonoError('')
    }

    if (correo === '') {
      setCorreoError('Campo obligatorio')
    } else {
      if (validateMail(correo)) {
        setCorreoError('')
      } else {
        setCorreoError('Correo inválido')
      }
    }

    if (web === '') {
      setWebError('Campo obligatorio')
    } else {
      if (validateWebUrl(web)) {
        setWebError('')
      } else {
        setWebError('Web inválida')
      }
    }


  }, [nombre, razon, rut, codigo, telefono, correo, web])

  return (
    <Grid
      container
      item
      xs={12}
      spacing={4}
      style={{
        marginTop: 5,
        marginBottom: 5,
        paddingLeft:15,
        paddingRight:15,
        marginLeft:1,
        marginRight:1
      }}>
      <Grid item xs={12}>
        <h3>Identificación del prestador</h3>
      </Grid>
      <Grid item xs={4}>
        <AppTextInput
          //inputProps={{style: { fontSize: 14 }}}
          disabled
          size={"small"}
          InputLabelProps={{ style: LABEL_INPUT_FONT_SIZE }}
          fullWidth
          variant="outlined"
          label="Nombre del Prestador"
          value={nombre}
          onChange={e => {
            if (e.target.value.length < 100) {
              setNombre(e.target.value);
            }

          }}
          helperText={nameError}
          onBlur={() => {
            validateField(nombre, setNameError)
          }}
        />
      </Grid>
      <Grid item xs={4}>
        <AppTextInput
          disabled
          size={"small"}
          InputLabelProps={{ style: LABEL_INPUT_FONT_SIZE }}
          fullWidth
          variant="outlined"
          label="Razón Social"
          value={razon}
          onChange={e => {
            if (e.target.value.length < 100) {
              setRazon(e.target.value);
            }
          }}
          helperText={razonSocialError}
          onBlur={() => { validateField(razon, setRazonSocialError) }}
        />
      </Grid>
      <Grid item xs={4}>
        <AppTextInput
          disabled
          size={"small"}
          InputLabelProps={{ style: LABEL_INPUT_FONT_SIZE }}
          fullWidth
          variant="outlined"
          label="R.U.T."
          value={rut}
          onChange={e => {
            handleRutChange(e, setRut)
          }}
          helperText={rutError}
          onBlur={() => {
            if (!validateRut(rut)) {
              setRutError('RUT inválido')
            } else {
              setRutError('')
            }
          }}
        />
      </Grid>
      <Grid item xs={4}>
        <AppTextInput
          disabled
          size={"small"}
          InputLabelProps={{ style: LABEL_INPUT_FONT_SIZE }}
          fullWidth
          variant="outlined"
          label="Código DEIS"
          value={codigo}
          onChange={e => {
            const regex = /^[0-9]+$/;
            if (regex.test(e.target.value) || e.target.value === '') {
              if (e.target.value.length < 10) {
                setCodigo(e.target.value);
              }
            }
          }}
          helperText={deisError}
          onBlur={() => { validateField(codigo, setDeisError) }}
        />
      </Grid>
      {/*       <Grid item xs={4}>
        <AppTextInput
          size={"small"}
          InputLabelProps={{ style: LABEL_INPUT_FONT_SIZE }}
          fullWidth
          variant="outlined"
          label="Teléfono de contacto"
          value={telefono}
          onChange={e => {
            const regex = /^[0-9]+$/;
            if (regex.test(e.target.value) || e.target.value === '') {
              if (e.target.value.length < 10) {
                setTelefono(e.target.value);
              }
            }

          }}
          helperText={telefonoError}
          onBlur={() => { validateField(telefono, setTelefonoError) }}
        />
      </Grid> */}

      <Grid item xs={4}>
        <AppTextInput
          tooltip={'el formato debe ser: +56911111111'}
          size={"small"}
          InputLabelProps={{ style: LABEL_INPUT_FONT_SIZE }}
          fullWidth
          variant="outlined"
          label="Teléfono de contacto"
          value={telefono}
          onChange={e => {
            let input = e.target.value;
            if (!input.startsWith("+56")) {
              setTelefono('+56');
              return;
            }
            const regex = /^\+56([1-9][0-9]{0,8}|)$/;
            if (regex.test(input)) {
              setTelefono(input);
            }
          }}
          helperText={telefonoError}
          onBlur={() => {
            if (telefono.length === 12) {
              setTelefonoError("");
            } else {
              setTelefonoError("El número debe tener 9 dígitos después de +56.");
            }
          }}
        />
      </Grid>

      <Grid item xs={4}>
        <AppTextInput
          tooltip={'El formato debe ser: miCorreo@ejemplo.cl'}
          size={"small"}
          InputLabelProps={{ style: LABEL_INPUT_FONT_SIZE }}
          fullWidth
          variant="outlined"
          label="Correo electrónico"
          value={correo}
          onChange={e => {
            if (e.target.value.length < 100) {
              setCorreo(e.target.value)
            }

          }}
          helperText={correoError}
          onBlur={() => {
            if (correo !== '') {
              const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
              if (regex.test(correo)) {
                setCorreoError('');
              } else {
                setCorreoError('Correo inválido')
              }
            } else {
              validateField(correo, setCorreoError)
            }
          }}
        />
      </Grid>
      <Grid item xs={4}>
        <AppTextInput
          tooltip={'El formato debe ser www.mipagina.cl'}
          size="small"
          InputLabelProps={{ style: LABEL_INPUT_FONT_SIZE }}
          fullWidth
          variant="outlined"
          label="Página Web"
          value={web}
          //inputProps={{ style: { fontSize: 14 } }} // 👈 aquí controlas el tamaño del texto del input
          onChange={e => {
            if (e.target.value.length < 100) {
              setWeb(e.target.value);
            }
          }}
          helperText={webError}
          onBlur={() => {
            if (web !== '') {
              const regex = /^(https:\/\/)?(www\.)?[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})+(\/[^\s]*)?$/;
              if (regex.test(web)) {
                setWebError('');
              } else {
                setWebError('Dirección web inválida');
              }
            } else {
              validateField(web, setWebError);
            }
          }}
        />
      </Grid>
    </Grid>
  );
};

export default IdentificacionPrestador;
